import "./productCard.css";
import { Link } from "react-router-dom";

function ProductCard({
  image,
  text,
  tags = [],
  onTagClick,
  detailLink,
  detailLinkLabel,
  overlayTitle,
  overlayHint,
  badgeText,
}) {
  const hasTags = tags.length > 0;

  const handleTagClick = (event, tag) => {
    event.preventDefault();
    event.stopPropagation();
    onTagClick?.(tag);
  };

  return (
    <div className={`productcard-container ${hasTags ? "is-interactive" : ""}`}>
      <div className="image-box">
        <img src={image} alt={text} />
        {hasTags ? (
          <div className="productcard-overlay">
            <div className="productcard-overlay-inner">
              {overlayTitle ? (
                <p className="productcard-eyebrow">{overlayTitle}</p>
              ) : null}

              <div className="productcard-tags">
                {tags.map((tag) => (
                  <button
                    key={tag.name}
                    type="button"
                    className="productcard-tag"
                    onClick={(event) => handleTagClick(event, tag)}
                  >
                    <span className="productcard-tag-label">
                      {tag.tagLabel || tag.name}
                    </span>
                    <span className="productcard-tag-count">
                      {tag.src?.length || 0}
                    </span>
                  </button>
                ))}
              </div>

              <div className="productcard-overlay-footer">
                {overlayHint ? (
                  <span className="productcard-overlay-hint">{overlayHint}</span>
                ) : (
                  <span />
                )}

                {detailLink && detailLinkLabel ? (
                  <Link to={detailLink} className="productcard-detail-link">
                    {detailLinkLabel}
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <div className="text-row">
        <h3 className="text">{text}</h3>
        {badgeText ? <span className="productcard-badge">{badgeText}</span> : null}
      </div>
    </div>
  );
}

export default ProductCard;
